import { defineComponent } from 'vue';
export const optionProps = {
    value: String,
    disabled: Boolean,
    label: [String, Number, Function],
};
export default defineComponent({
    compatConfig: { MODE: 3 },
    name: 'Option',
    props: optionProps,
    render(_props, { slots }) {
        return slots.default?.();
    },
});
